<template lang="pug">
  .inicio-main-dash
    .landing.landing-vivemas
      
      .g-overlay(v-show="overlay")
      .modal-category(v-show="modalCategory")
        .modal-category-content
          svg(width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg",@click="closeModalCategory")
            path(d="M7.31863 0.516113L1.03711 6.79764" stroke="#0855C4" stroke-width="1.04692" stroke-linecap="round" stroke-linejoin="round")
            path(d="M1.03711 0.516113L7.31863 6.79764" stroke="#0855C4" stroke-width="1.04692" stroke-linecap="round" stroke-linejoin="round")
  
          .list-category.justify-space-around.g-flex-wrap(v-if="categories.length-4>0")
            div(v-for="index in categories.length-4" :key="categories[index+3].ordinal")
              article(@click="goToPath(categories[index+3].name);gtmChangeCategory(categories[index+3].name);gtmBtn(categories[index+3].name)" :class="(categories[index+3].name === categoryTitle) ? 'selected-box-modal' : ''")
                figure(:class="{'img-otros-formatter': categories[index+3].name === 'Otros' }")
                  img(:src="categories[index+3].img")
                h3 {{categories[index+3].name}}
      section
        PopupNotification(:api="apiNot" :query="parametros" v-if="loadPopup")
      section
        v-container.container-button-popup-city
          .d-lg-flex(style="justify-content: space-between;align-items: center;")
            .landing-navigation.d-inline-flex.align-center(style="flex: none;")
              figure(@click="goToHome" style="cursor: pointer;")
                img(src="../assets/landing/icon-home.png", alt="imagen del home")
              .d-flex.align-center(v-for="(item, index) in menuNav", :key="index" @click="goToPath(item.option, true)" style="cursor: pointer;")
                  svg(width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M0.310022 0.710022C0.217319 0.802536 0.143771 0.912424 0.0935898 1.0334C0.0434083 1.15437 0.0175781 1.28405 0.0175781 1.41502C0.0175781 1.54599 0.0434083 1.67567 0.0935898 1.79665C0.143771 1.91762 0.217319 2.02751 0.310022 2.12002L4.19002 6.00002L0.310022 9.88002C0.123045 10.067 0.0180016 10.3206 0.0180016 10.585C0.0180016 10.8494 0.123045 11.103 0.310022 11.29C0.497 11.477 0.750596 11.582 1.01502 11.582C1.27945 11.582 1.53304 11.477 1.72002 11.29L6.31002 6.70002C6.40273 6.60751 6.47627 6.49762 6.52646 6.37665C6.57664 6.25567 6.60247 6.12599 6.60247 5.99502C6.60247 5.86405 6.57664 5.73437 6.52646 5.6134C6.47627 5.49242 6.40273 5.38253 6.31002 5.29002L1.72002 0.700022C1.34002 0.320022 0.700022 0.320022 0.310022 0.710022Z" fill="#0855C4")
                  p(:class="{'active-nav': item.active}") {{item.name}}
            .mt-3.mt-lg-0.button-popup
              button.button-popup-city(@click="openPopupMethod")
                svg(width="32" height="32" viewbox="0 0 32 3k2" fill="none")
                  path(d="M13 1.44446C10.7504 1.44634 8.59295 2.33834 6.99888 3.92565C5.40481 5.51296 4.50363 7.66657 4.49219 9.91612C4.49219 13.2889 6.38441 16.1128 7.77108 18.1711L8.02385 18.5467C9.4035 20.5462 10.8835 22.4746 12.4583 24.3245L13.0072 24.9672L13.5561 24.3245C15.1306 22.4745 16.6107 20.5461 17.9905 18.5467L18.2433 18.1639C19.6227 16.1056 21.515 13.2889 21.515 9.91612C21.5035 7.66532 20.6013 5.51062 19.0057 3.9231C17.4101 2.33559 15.2508 1.44443 13 1.44446ZM17.0372 17.3333L16.7772 17.7161C15.535 19.5795 13.8883 21.6667 13 22.6995C12.1477 21.6667 10.465 19.5795 9.22274 17.7161L8.96997 17.3333C7.69163 15.4267 5.93663 12.8195 5.93663 9.88724C5.93663 8.95967 6.11933 8.04118 6.4743 7.18422C6.82926 6.32725 7.34954 5.5486 8.00543 4.8927C8.66133 4.23681 9.43998 3.71653 10.2969 3.36157C11.1539 3.0066 12.0724 2.8239 13 2.8239C13.9275 2.8239 14.846 3.0066 15.703 3.36157C16.5599 3.71653 17.3386 4.23681 17.9945 4.8927C18.6504 5.5486 19.1707 6.32725 19.5256 7.18422C19.8806 8.04118 20.0633 8.95967 20.0633 9.88724C20.0633 12.8483 18.3155 15.4556 17.0372 17.3333Z" fill="#0855C4")
                  path(d="M13.0006 4.85327C12.1822 4.85327 11.3821 5.09598 10.7015 5.55071C10.021 6.00543 9.49054 6.65175 9.17732 7.40793C8.8641 8.16411 8.78214 8.9962 8.94182 9.79895C9.1015 10.6017 9.49564 11.3391 10.0744 11.9178C10.6532 12.4966 11.3905 12.8907 12.1933 13.0504C12.996 13.2101 13.8281 13.1281 14.5843 12.8149C15.3405 12.5017 15.9868 11.9713 16.4415 11.2907C16.8963 10.6102 17.139 9.81009 17.139 8.9916C17.139 7.89405 16.703 6.84145 15.9269 6.06536C15.1508 5.28927 14.0982 4.85327 13.0006 4.85327ZM13.0006 11.6855C12.4678 11.6855 11.947 11.5275 11.504 11.2315C11.061 10.9355 10.7157 10.5148 10.5118 10.0225C10.3079 9.53027 10.2546 8.98862 10.3585 8.46605C10.4625 7.94349 10.719 7.46348 11.0958 7.08674C11.4725 6.70999 11.9525 6.45342 12.4751 6.34948C12.9977 6.24553 13.5393 6.29888 14.0315 6.50278C14.5238 6.70667 14.9445 7.05195 15.2405 7.49496C15.5365 7.93797 15.6945 8.4588 15.6945 8.9916C15.6926 9.70482 15.408 10.3882 14.903 10.8918C14.398 11.3954 13.7139 11.6783 13.0006 11.6783V11.6855Z" fill="#0855C4")
                span Ciudad {{': ' + citySelected.name}}
                svg(width="25" height="32" viewbox="0 0 32 3k2" fill="none")
                  path(d="M7 9.88868L12.657 15.5713L18.314 9.88868L17.607 9.17847L12.657 14.1509L7.707 9.17847L7 9.88868Z" fill="#0855C4")
            // Searching
            .landing-search.mt-lg-0.search-benefits
              svg(width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M28.5435 28.5442C28.4783 28.6094 28.401 28.661 28.3159 28.6963C28.2308 28.7315 28.1396 28.7497 28.0475 28.7497C27.9554 28.7497 27.8642 28.7315 27.7791 28.6963C27.694 28.661 27.6167 28.6094 27.5516 28.5442L22.3454 23.3382C20.2881 25.1376 17.612 26.0671 14.8822 25.9302C12.1524 25.7933 9.58269 24.6009 7.7157 22.6047C5.84871 20.6085 4.83063 17.9648 4.87648 15.232C4.92233 12.4992 6.02852 9.89114 7.96142 7.95869C9.89432 6.02624 12.5026 4.92067 15.2355 4.87547C17.9683 4.83026 20.6117 5.84896 22.6075 7.71642C24.6033 9.58388 25.7951 12.1539 25.9313 14.8837C26.0675 17.6135 25.1374 20.2894 23.3375 22.3463L28.5435 27.5523C28.6086 27.6174 28.6603 27.6947 28.6956 27.7798C28.7309 27.865 28.749 27.9562 28.749 28.0483C28.749 28.1404 28.7309 28.2317 28.6956 28.3168C28.6603 28.4019 28.6086 28.4791 28.5435 28.5442ZM15.422 24.5409C17.2256 24.5409 18.9886 24.0061 20.4882 23.0041C21.9878 22.0021 23.1566 20.5779 23.8468 18.9117C24.537 17.2454 24.7176 15.4119 24.3657 13.643C24.0139 11.8741 23.1454 10.2492 21.8701 8.97394C20.5948 7.69863 18.9699 6.83014 17.201 6.47828C15.4321 6.12643 13.5986 6.30701 11.9324 6.9972C10.2661 7.68739 8.84192 8.85619 7.83992 10.3558C6.83792 11.8554 6.30311 13.6184 6.30311 15.422C6.30583 17.8396 7.26745 20.1575 8.97699 21.867C10.6865 23.5766 13.0044 24.5382 15.422 24.5409Z" fill="#0855C4")
              input(type="text" placeholder="Busca lo que necesites" v-on:keyup="filterData($event, (categoryTitle === '')?'Beneficios':categoryTitle)")
              v-dialog(v-model="loader" persistent width="300")
                v-card(color="primary" dark="")
                  v-card-text
                    | {{loaderText}}
                    v-progress-linear.mb-0(indeterminate="" color="white")
      section
        v-container
          .d-flex.landing-detail-nav
            .effect-scale(v-for="index in (categories.length > 4)?4:categories.length" :key="categories[index-1].ordinal")
              article(@click="goToPath(categories[index-1].name);gtmChangeCategory(categories[index-1].name)" :class="(categories[index-1].name === categoryTitle)?'selected-box':''")
                figure(:class="{'img-viajes-formatter': categories[index-1].name === 'Viajes' }")
                  img(:src="categories[index-1].img" height="auto" width="42")
                figcaption(:class="{'figcaption-viajes-formatter': categories[index-1].name === 'Viajes' }") {{categories[index-1].name}}
            .effect-scale(v-if="categories.length > 4")
              article(@click="openModalCategory")
                figure.img-ver-mas-formatter
                  img(src="../assets/landing/ver-mas.png")
                figcaption.figcaption-ver-mas-formatter Ver más
      section
        v-container
          h2 {{(categoryTitle === '')?'Beneficios':categoryTitle}}
          div 
            CardsPromotion(:api="api" :query="parametros" :saveGTM="switchAction" :origin="'ZonaSegura'" v-if="loaded")
      
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex'
  import Navigation from '@/components/LandingNavig.vue'
  import CardsPromotion from 'is-card-benefit/src/components/CardsPromotion.vue'
  import PopupNotification from 'is-popup-notification/src/components/Popup.vue'
  
  import moment from 'moment';
  
  export default{
    components: {
      Navigation,
      PopupNotification,
      CardsPromotion,
    },
    data: () => ({
      apiNot: {
        url: process.env.API_VIVEMAS,
      },
      api: {
        url: process.env.API_VIVEMAS + '/benefits',
      },
      getUrl: process.env.API_VIVEMAS + '/benefits',
      parametros: {},
      loaded: false,
      loadPopup: false,
      categories: [],
      categoryTitle: '',
      benefit: '',
      brand: '',
      menuNavBase: [
        {
          active: false,
          name: 'Vive+',
          path: '/vivemas',
          option: ''
        },
        {
          active: false,
          name: 'Beneficios',
          path: '/vivemas-beneficios',
          option: ''
        }
      ],
      loader: false,
      loaderText: '',
      menuNav: [],
      modalCategory: false,
      callModal: false,
      showService: true,
      showInfo: false,
      overlay: false,
      dataBenefits: [],
      skip: 0,
      limit: 12,
      counter: 0,
      search: '',
      isOnlySoat: false,
      productsArray: [],
      routeName: 'BenefitsVivemas',
      searchPersistent: '',
      citySelected: {
        name: 'Todos'
      },
      openPopup: false
    }),
    mounted () {
      this.categoryTitle = this.$route.query.category
      this.benefit = this.$route.query.benefit || ''
      this.menuNav = []
      this.menuNav.push(...this.menuNavBase.filter(opt => !(opt.path === '/vivemas' && this.isOnlySoat)))
      if (this.categoryTitle && this.categoryTitle !== '') {
        this.menuNav.push({
          active: true,
          name: this.categoryTitle,
          path: '/vivemas-descuentos?category=' + this.categoryTitle,
          option: this.categoryTitle
        })
        this.gtmSend(this.categoryTitle)
      } else {
        this.menuNav = this.menuNav.map(opt => {
          opt.active = opt.name === 'Descuentos'
          return opt
        })
      }
      this.dataBenefits = []
      this.getBenefitsCallback()
      this.categories = this.benefitCategories || []
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
      fetch(process.env.API_VIVEMAS + '/categories/benefits', requestOptions)
        .then(response => response.json())
        .then(data => {
          this.$store.commit('vivemas/setBenefitCategories', data.data)
          this.categories = data.data
        })
        .catch(error => console.error('Error getBenefitsCategories: ',error));
      //- this.getBenefitsCategories().then(res => {
      //-   this.$store.commit('vivemas/setBenefitCategories', res.data.data)
      //-   this.categories = res.data.data
      //- }).catch(err => {
      //- })
    },
    methods: {
      ...mapActions('vivemas', ['getBenefitsCategories']),
      ...mapActions('event', ['eventLog']),
      setDataTracking (tracking) {
        tracking.push(moment().format('DD/MM/YYYY'))
        tracking.push(this.basicInfo.numeroDocumento)
        
        let data = {"data": [ tracking]}
        fetch(process.env.API_VIVEMAS_TRACKING + '?startCell=a2', {method: 'POST', body: JSON.stringify(data)})
        .then(response => response.json())
        .then(data => {
          // console.log('data: ', data)
        })
        .catch(error => console.error('Error getBenefitsCategories: ',error));
        //- return resp
      },
      closeModalCategory () {
        this.modalCategory = false
        this.overlay = false
      },
      openModalCategory () {
        this.modalCategory = !this.modalCategory
        this.overlay = true
      },
      switchAction (UAT, GA4) {
        this.registerGTM(UAT, GA4)
      },
      getBenefitsCallback (searchAnalytics = '') {
        const req = {};
        req.skip = this.skip
        req.limit = this.limit
        const benefit = this.benefit;
        const brand = this.brand;
        const search = this.search;
        const categoryTitle = this.categoryTitle;
        const numeroDocumento = this.basicInfo.numeroDocumento;
        const cityName = this.citySelected.name;
  
        if (brand !== '') {
          req.brand = brand;
        }
        if (benefit !== '') {
          req.benefit = benefit;
        }
  
        if (search !== '') {
          req.search = search;
        } else if (categoryTitle && categoryTitle !== '') {
          req.category = categoryTitle;
        }
  
        if (numeroDocumento) {
          req.numeroDocumento = numeroDocumento;
          req.email = this.basicInfo.correo
        }
  
        if (cityName !== 'Todos' && cityName !== '') {
          req.city = cityName;
        }
  
        this.parametros = req;
          this.loadPopup = true
  
        this.loaded = true
      },
      goToHome () {
        this.$router.push('/')
      },
      goToPath (option, changeRouter) {
        // console.log('goPath', option)
        this.search = ''
        this.benefit = ''
        this.categoryTitle = option
        this.dataBenefits = []
        this.getBenefitsCallback()
        let router = { name: this.routeName }
        if (option !== '' && option !== undefined) {
          // console.log('dentro de option: ', option)
          this.menuNav = []
          if (this.citySelected.name !== 'Todos') {
            router.query = {category: option, city: this.citySelected.name}
            this.menuNav.push(...this.menuNavBase.filter(opt => !(opt.path === '/vivemas' && this.isOnlySoat)), {
              active: true,
              name: this.categoryTitle,
              path: '/vivemas-descuentos?category=' + this.categoryTitle + '&city=' + this.citySelected,
              option: this.categoryTitle
            })
          } else {
            router.query = {category: option}
            this.menuNav.push(...this.menuNavBase.filter(opt => !(opt.path === '/vivemas' && this.isOnlySoat)), {
              active: true,
              name: this.categoryTitle,
              path: '/vivemas-descuentos?category=' + this.categoryTitle + '&city=' + this.citySelected,
              option: this.categoryTitle
            })
          }
          this.gtmSend(option)
          //- this.$amplitude.getInstance()
          //-   .logEvent('Selección de Categoria', {'Tipo de Beneficio': 'Descuentos', 'Categoria': option, 'Canal de consulta': 'Zona Segura'})
          //- if (this.modalCategory) {
          //-   this.gtmChangeCategory('Descuentos', option, 'Ver más - ')
          //- } else {
          //-   this.gtmChangeCategory('Descuentos', option)
          //- }
          this.menuNav = this.menuNav.map(opt => {
            opt.active = opt.name === option
            return opt
          })
          this.closeModalCategory()
        } else {
          this.menuNav = []
          // console.log('else: ', this.citySelected)
          if (this.citySelected.name !== '' && this.citySelected.name !== 'Todos') {
            // console.log('option else:: ', this.citySelected.name)
            if (this.categoryTitle !== '') {
              router.query = { category: this.categoryTitle, city: this.citySelected.name }
              this.menuNavBase[0].path = '/beneficios?category=' + this.categoryTitle + 'city=' + this.citySelected
            } else {
              router.query = { city: this.citySelected.name }
              this.menuNavBase[0].path = '/beneficios?city=' + this.citySelected.name
            }
          }
          this.menuNav.push(...this.menuNavBase)
          this.menuNav = this.menuNav.map(opt => {
            opt.active = opt.name === 'beneficios'
            return opt
          })
        }
        if (changeRouter) {
          router = { name: 'Vivemas' }
        }
        this.$router.push(router).catch(() => {})
      },
      registerGTM (UAT, GA4) {
        UAT.category = 'Zona Segura'
        GA4['Nombre Sección'] = 'Zona Segura'
        this.$gtm.trackEvent(UAT);
        this.$gtm.trackEvent(GA4);
      },
      
      // EVENT - 51 - Elemento - Cambiar Categorías - ANALYTICS
      gtmChangeCategory (nameCategory) {
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección':  'Zona Segura',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Vive+ - Beneficio',
          'CTA':'Seleccionar categoría - ' + nameCategory
        });
        // UA
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Vive+ - Beneficio',
          'label': 'Seleccionar categoría - ' + nameCategory
        });
      },
      gtmBtn (nameCategory) {
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Zona Segura',
          'TipoElemento': 'Ícono- Botón',
          'TipoAccion': 'Vive+ - Beneficio',
          'CTA':'Seleccionar botón - Ver más  - ' + nameCategory
        });
        // UA
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Vive+ - Beneficio',
          'label': 'Seleccionar botón - Ver más  - ' + nameCategory
        });
      },
      filterData (evt, category) {
        evt.preventDefault()
        this.benefit=''
        this.categoryTitle = ''
        this.search = evt.target.value
        if (evt.key === 'Enter') {
          //- this.page = 1
          //- this.skip = 0
          //- this.dataBenefits = []
          this.gtmSearch(this.search, category)
          this.getBenefitsCallback()
        }
      },
      gtmSend (path) {
        let formatPagePath = '/zona-segura/vivemas/beneficios/?category=' + this.removeAcents(path.toLowerCase().split(' y ').join(' ').split(' de ').join(' ')).split(' ').join('-')
        this.$gtm.trackEvent({
          event: 'virtualPage',
          category: 'Zona Segura',
          pageName: path,
          pagePath: formatPagePath
        })
        this.$gtm.trackEvent({
          event: 'virtualPage',
          category: 'Zona Segura',
          pageName: path,
          pagePath: formatPagePath
        })
      },
      gtmSearch (search, category) {
        // GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección':  'Zona Segura',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Vive+ - Buscador',
          'CTA': search,
          'Categoría': category
        });
        // UA
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Vive+ - Buscador',
          'label': search,
          'dimension27' : category
        });
      },
      removeAcents (cadena) {
        const acentos = {'%': '', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U'}
        return cadena.split('').map(letra => acentos[letra] || letra).join('').toString()
      },
      citySelectedMethod (item) {
        // console.log('citySelectedMethod:', item.name, item.id)
        this.openPopup = false
        this.citySelected.name = item.name
        this.citySelected.id = item.id
        this.goToPath(this.categoryTitle)
      },
      openPopupMethod () {
        this.openPopup = !this.openPopup
      }
    },
    computed: {
      ...mapGetters('vivemas', ['benefitCategories', 'benefits', 'tracking']),
      ...mapGetters('user', ['basicInfo'])
    },
    created () {
      let products = localStorage.getItem('products')
      if (products && products !== null) {
        this.productsArray = JSON.parse(products).map(p => p.toLowerCase())
        this.isOnlySoat = this.productsArray.length === 1 && this.productsArray.includes('soat')
      }
    },
    
  }
  </script>
  
  <style>
    @import url('../assets/css/general.css');
    
    article.g-flex.g-align-center {
        margin-left: 30px;
    }
  
    .list-category h3 {
      color: #535D66;
      margin-bottom: 25px;
      margin-top: -10px;
    }
  
    .v-tooltip__content {
      background: #454A6C;
    }
  
    .modal-detalle-item-content .g-flex p a {
      font-size: 14px;
    }
  
    .flex-container {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    }
  
    .space-between {
      justify-content: space-between;
    }
  
    .selected-box {
      border-color: #0855c4 !important;
    }
  
    .selected-box-modal {
      /*
      border-color: #0855c4 !important;
      border: 1px solid;
      */
      width: 125px !important;
      margin-left: 30px !important;
      height: 165px;
      border-radius: 10px;
    }
    .selected-box-modal figure {
      border: 1px solid #0855c4 !important;
    }
    span.title_back_solicitudes {
      font-weight: 500;
    }
  
    @media screen and (max-width: 768px) {
      .modal-content-data {
        height: 30rem;
        overflow: auto
      }
  
      .modal-detalle-content .col-1 {
          padding-top: 20px;
      }
  
      article.g-flex.g-align-center {
        margin-left: 0px;
      }
    }
  
    @media only screen and (max-width: 400px) {
      .modal-content-data {
        height: 28rem;
        overflow: auto
      }
    }
    .img-viajes-formatter > img{
      position: relative;
      left: -1em;
    }
  
    .figcaption-viajes-formatter{
      position: relative;
      left: -1em;
    }
  
    .img-ver-mas-formatter > img{
      display: block;
      position: relative;
      left: -1em;
    }
  
    .figcaption-ver-mas-formatter{
      position: relative;
      left: -0.5em;
    }
  </style>
  


// WEBPACK FOOTER //
// src/pages/LandingPrincipal.vue